export const TEXT = {
    JOIN_GROUP: 'Join Group',
    JOIN_GROUP_DESCRIPTION: 'Find groups by name or url',
    GROUP_SEARCH_MATCH: 'Press Enter to add group to list.'
};